import { render, staticRenderFns } from "./saveManagement.vue?vue&type=template&id=05618e0f"
import script from "./saveManagement.vue?vue&type=script&lang=js"
export * from "./saveManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05618e0f')) {
      api.createRecord('05618e0f', component.options)
    } else {
      api.reload('05618e0f', component.options)
    }
    module.hot.accept("./saveManagement.vue?vue&type=template&id=05618e0f", function () {
      api.rerender('05618e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/manage/saveManagement.vue"
export default component.exports